import { render, staticRenderFns } from "./EventsPlacesRelationChosenWidget.vue?vue&type=template&id=66e2a7dc&"
import script from "./EventsPlacesRelationChosenWidget.vue?vue&type=script&lang=js&"
export * from "./EventsPlacesRelationChosenWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66e2a7dc')) {
      api.createRecord('66e2a7dc', component.options)
    } else {
      api.reload('66e2a7dc', component.options)
    }
    module.hot.accept("./EventsPlacesRelationChosenWidget.vue?vue&type=template&id=66e2a7dc&", function () {
      api.rerender('66e2a7dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/feeds/byEntity/EventsPlacesRelationChosenWidget.vue"
export default component.exports